// Arabic message translations
export const messages = {
  // Common UI elements
  Send: "إرسال",
  "Clear chat": "مسح المحادثة",
  Support: "الدعم",
  Settings: "الإعدادات",
  Language: "اللغة",
  Theme: "المظهر",
  "Font Size": "حجم الخط",
  "Select language": "اختر اللغة",

  // Chat interface
  "Type your message...": "اكتب رسالتك...",
  "Thinking...": "جاري التفكير...",
  "Labor Law Expert": "خبيرة نظام العمل",
  "by MJ": "بواسطة MJ",
  "Leen": "Leen",

  // Frameworks
  "Automatic detection": "كشف تلقائي",
  "Essential Cybersecurity Controls": "الضوابط الأساسية للأمن السيبراني",
  "Cloud Cybersecurity Controls": "ضوابط الأمن السيبراني للحوسبة السحابية",
  "Critical Systems Cybersecurity Controls":
    "ضوابط الأمن السيبراني للأنظمة الحساسة",
  "Data Cybersecurity Controls": "ضوابط الأمن السيبراني للبيانات",
  "Organizations' Social Media Accounts Cybersecurity Controls":
    "ضوابط الأمن السيبراني لحسابات التواصل الاجتماعي للجهات",
  "Operational Technology Cybersecurity Controls":
    "ضوابط الأمن السيبراني للتقنيات التشغيلية",
  "Telework Cybersecurity Controls": "ضوابط الأمن السيبراني للعمل عن بعد",

  // Models
  "Claude by Anthropic": "كلود من أنثروبيك",
  "DeepSeek by Groq": "ديب سيك من جروك",
  "MJ Lab Mode": "وضع مختبر MJ",

  // Messages
  "Language changed to {locale}": "تم تغيير اللغة إلى {locale}",
  "Hello, I am {{name}}, an AI assistant made by MJ.":
    "مرحبًا، أنا {{name}}، مساعدة ذكاء اصطناعي من تطوير MJ.",
  "I am expert in labor laws and regulations for Saudi Arabia.":
    "أنا خبيرة في قوانين وأنظمة العمل في المملكة العربية السعودية.",
  "Ask me a question, and I will gladly answer you.":
    "اسألني سؤالا، وسأجيب عليك بكل سرور.",
  "Do not share confidential data.": "لا تشارك البيانات السرية.",
  "I am powered using": "أنا أعمل باستخدام",

  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.":
    "**إخلاء مسؤولية:** {{name}} هي مساعدة ذكاء اصطناعي تجريبية مصممة للرد باستخدام بيانات من قوانين وأنظمة العمل السعودية، مع تجنب الافتراضات أو عدم الدقة. أنا لست مسؤولاً عن سلوكها أو صحة إجاباتها.",

  // Error messages
  "An error occurred": "حدث خطأ",
  "Failed to change language": "فشل تغيير اللغة",
  "Please try again": "يرجى المحاولة مرة أخرى",
  "Connection lost": "انقطع الاتصال",
  "Reconnecting...": "جاري إعادة الاتصال...",
  "Nothing to clear": "لا يوجد شيء للمسح",
  "All messages cleared": "تم مسح جميع الرسائل",
  "All data cleared": "تم مسح جميع البيانات",
  "Storage limit reached": "تم الوصول إلى حد التخزين",
  "Some older messages were removed to save space.":
    "تمت إزالة بعض الرسائل القديمة لتوفير المساحة.",
  Error: "خطأ",

  // Tooltips
  "Increase font size": "زيادة حجم الخط",
  "Decrease font size": "تقليل حجم الخط",
  "Reset font size": "إعادة تعيين حجم الخط",
  "Change theme": "تغيير المظهر",
  "Support the project": "دعم المشروع",

  // Character count
  "{{remainingChars}} character left": "حرف {{remainingChars}} متبقي",
  "{{remainingChars}} characters left": "{{remainingChars}} حرف متبقي",

  // Message actions
  "Message copied to clipboard": "تم نسخ الرسالة إلى الحافظة",
  Read: "قراءة",
  Summarize: "تلخيص",

  // Ice Breakers Dialog
  "Message Suggestions": "اقتراحات الرسائل",
  "Select a question to quickly start a conversation about Saudi labor laws.":
    "اختر سؤالاً لبدء محادثة حول قوانين العمل السعودية.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?":
    "ما هي الحقوق الأساسية للموظفين بموجب قانون العمل السعودي؟ هل يمكنك تقديم نظرة عامة بسيطة؟",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?":
    "ما هي التزامات صاحب العمل فيما يتعلق بساعات العمل والعمل الإضافي والإجازات في المملكة العربية السعودية؟",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?":
    "كيف يتعامل قانون العمل السعودي مع إنهاء العمل ومكافآت نهاية الخدمة؟",

  // Audio Player Dialog
  "AI Summary": "ملخص الذكاء الاصطناعي",
  "Listen to the summarized response using our AI Service.":
    "استمع إلى الرد الملخص باستخدام خدمة الذكاء الاصطناعي.",
  "Generating summary...": "جاري إنشاء الملخص...",
  "Preparing audio...": "جاري تحضير الصوت...",

  // Audio Player Error Messages
  "Failed to process text. Please try again.":
    "فشلت معالجة النص. يرجى المحاولة مرة أخرى.",
  "Failed to auto-play audio. Click play to try again.":
    "فشل تشغيل الصوت تلقائيًا. انقر على تشغيل للمحاولة مرة أخرى.",
  "Failed to load audio. Please try again.":
    "فشل تحميل الصوت. يرجى المحاولة مرة أخرى.",
  "Audio playback was aborted.": "تم إلغاء تشغيل الصوت.",
  "Network error occurred while loading audio.":
    "حدث خطأ في الشبكة أثناء تحميل الصوت.",
  "Audio decoding failed.": "فشل فك تشفير الصوت.",
  "Audio format not supported.": "تنسيق الصوت غير مدعوم.",
  "Failed to setup audio playback": "فشل إعداد تشغيل الصوت",
  "Failed to generate speech": "فشل توليد الكلام",
  "Failed to generate audio. Please try again.":
    "فشل إنشاء الصوت. يرجى المحاولة مرة أخرى.",
  "Failed to play audio. Please try again.":
    "فشل تشغيل الصوت. يرجى المحاولة مرة أخرى.",

  // Brand names (do not translate)
  Leen: "Leen",
  
  // Update Notifications
  "update.updateAvailable": "تحديث متاح",
  "update.newVersionAvailable": "الإصدار الجديد {{version}} متاح",
  "update.refreshToApply": "قم بالتحديث لتطبيق أحدث الميزات والتحسينات",
  "update.later": "لاحقًا",
  "update.updateNow": "تحديث الآن",
  
  // CSAT Feedback
  "We Value Your Feedback": "نقدر آراءك",
  "Give Feedback": "أعط رأيك",
  "How would you rate your experience?": "كيف تقيم تجربتك؟",
  "Very Dissatisfied": "غير راضٍ تماماً",
  "Dissatisfied": "غير راضٍ",
  "Neutral": "محايد",
  "Satisfied": "راضٍ",
  "Very Satisfied": "راضٍ تماماً",
  "Select a rating": "اختر تقييماً",
  "Comments or Bug Report": "تعليقات أو تقرير خطأ",
  "Please share your thoughts or report any issues...": "يرجى مشاركة أفكارك أو الإبلاغ عن أي مشاكل...",
  "Contact Number": "رقم الاتصال",
  "Feedback Type": "نوع التعليق",
  "Select a feedback type": "اختر نوع التعليق",
  "Loading...": "جاري التحميل...",
  "No feedback types available": "لا توجد أنواع تعليقات متاحة", 
  "(Optional)": "(اختياري)",
  "Feedback Submitted": "تم إرسال التعليق",
  "Thank you for your rating!": "شكراً على تقييمك!",
  "Thank you for your bug report!": "شكراً على الإبلاغ عن الخطأ!",
  "Thank you for your idea!": "شكراً على فكرتك!",
  "Rating Required": "التقييم مطلوب",
  "Please select a rating before submitting.": "يرجى اختيار تقييم قبل الإرسال",
  "Submit Feedback": "إرسال التعليق",
  "Submitting...": "جاري الإرسال...",
  "Cancel": "إلغاء",
  "Close": "إغلاق",
  "General": "عام",
  "Bug": "خطأ",
  "Idea": "فكرة",
  
  // Feedback Dashboard
  "Feedback Dashboard": "لوحة التعليقات",
  "Total Feedbacks": "إجمالي التعليقات",
  "All-time submissions": "جميع الإرسالات",
  "Average Rating": "متوسط التقييم",
  "Out of 5 stars": "من 5 نجوم",
  "Feedback with Comments": "تعليقات مع ملاحظات",
  "Detailed feedback": "تعليقات مفصلة",
  "Rating Distribution": "توزيع التقييمات",
  "Breakdown of user satisfaction": "تفصيل رضا المستخدمين",
  "Rating Percentage": "نسبة التقييمات",
  "Proportion of each rating": "نسبة كل تقييم",
  "Responses": "الردود",
  "All Feedback": "جميع التعليقات",
  "Detailed view of user submissions": "عرض مفصل لإرسالات المستخدمين",
  "ID": "الرقم",
  "Rating": "التقييم",
  "Comment": "التعليق",
  "Contact": "الاتصال",
  "Date": "التاريخ",
  "Page": "الصفحة",
  "No feedback data available": "لا توجد بيانات تعليقات متاحة",
  "No comment": "لا يوجد تعليق",
  "Not provided": "غير متوفر",
  "Not available": "غير متاح",
  
  // Authentication
  "Login": "تسجيل الدخول",
  "Register": "التسجيل",
  "Leen Feedback Dashboard": "لوحة تحكم تعليقات لين",
  "Login to Dashboard": "تسجيل الدخول إلى لوحة التحكم",
  "Enter your credentials to access the admin dashboard": "أدخل بيانات اعتمادك للوصول إلى لوحة تحكم المشرف",
  "Username": "اسم المستخدم",
  "Password": "كلمة المرور",
  "Confirm Password": "تأكيد كلمة المرور",
  "Email": "البريد الإلكتروني",
  "Full Name": "الاسم الكامل",
  "Don't have an account?": "ليس لديك حساب؟",
  "Already have an account?": "لديك حساب بالفعل؟",
  "Login to continue": "تسجيل الدخول للمتابعة",
  "Create an account": "إنشاء حساب",
  "Passwords must match": "يجب أن تتطابق كلمات المرور",
  "Invalid email": "بريد إلكتروني غير صالح",
  "Required": "مطلوب",
  "Unauthorized": "غير مصرح",
  "You don't have permission to access this page.": "ليس لديك إذن للوصول إلى هذه الصفحة."
};
